import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.less']
})
export class LoaderComponent implements OnInit {

  constructor() { }

  @Input()
  text: string;

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/loader/loader.component.ts